document.addEventListener('DOMContentLoaded', function() {
    const tocLinks = document.querySelectorAll('.toc-nav a');
    const sections = Array.from(tocLinks).map(link => document.getElementById(link.getAttribute('data-section')));

    function onScroll() {
        let current = sections[0];
        for (const section of sections) {
            if (section && section.getBoundingClientRect().top - 180 < 0) {
                current = section;
            }
        }
        tocLinks.forEach(link => link.classList.remove('active'));
        if (!current) return;
        const activeLink = document.querySelector('.toc-nav a[data-section="' + current.id + '"]');
        if (activeLink) activeLink.classList.add('active');
    }
    window.addEventListener('scroll', onScroll);

    tocLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const section = document.getElementById(link.getAttribute('data-section'));
            if (section) {
                const y = section.getBoundingClientRect().top + window.pageYOffset - 60;
                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                });
                // Update URL anchor
                history.replaceState(null, '', '#' + section.id);
            }
        });
    });

    // onScroll();
});